import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { normalizeTaskContents, normalizeTaskHeader } from 'redesign/components/templates/ContentLists/TaskList/utils'
import { getTaskUrl } from 'redesign/components/templates/ContentLists/TaskList/utils/getTaskUrl'
import ContentCard from '../content-card'
import type { TaskReferenceCardProps } from './types'

const TaskReferenceCard: React.FC<TaskReferenceCardProps> = ({ task, testId, onTaskClick, icon }) => {
  const { t, locale } = useFavurTranslation()
  const { startText, secondaryText } = normalizeTaskContents({
    t,
    task,
    locale,
  })
  const title = normalizeTaskHeader({ task, isOffice: false, t })
  const taskUrl = getTaskUrl({ task })
  const status = task?.statusFe

  return (
    <ContentCard
      dataTestId={testId}
      header={{
        icon: <FramedIcon icon={icon} isFilled />,
        title,
        showChevron: true,
      }}
      onClick={() => {
        onTaskClick(taskUrl)
      }}
      statesProps={{
        startText,
        secondaryText,
        status,
      }}
    />
  )
}

export default TaskReferenceCard
